<template>
    <div class="mx-2 mx-lg-5">
        <div class="card mt-3">
            <div class="card-header">
                <h3>{{ $t("headers.nfcTagEdit") }}</h3>
            </div>
            <div class="card-body">
                <form class="row g-3" ref="form" @submit.prevent="submitForm">
                    <div class="col-12 col-md-6">
                        <label for="name" class="form-label">{{ $t("nfcTag.name") }}</label>
                        <input type="text" class="form-control" id="name" v-model="nfcTag.name" required />
                    </div>
                    <div class="col-12 col-md-6">
                        <label for="uid" class="form-label">{{ $t("nfcTag.id") }}</label>
                        <input type="text" class="form-control" id="uid" v-model="nfcTag.uid" readonly />
                    </div>
                    <div class="col-12 col-md-6">
                        <label for="order" class="form-label">{{ $t("nfcTag.order") }}</label>
                        <input type="number" class="form-control" id="order" v-model="nfcTag.order" required />
                    </div>

                    <div class="my-4">
                        <button class="btn btn-primary w-100 py-3 fw-bold fs-5 text-white" @click="submitForm">{{ $t("utils.saveChanges") }}</button>
                    </div>
                    <p class="form-text mb-0">* {{ $t("utils.requiredFields") }}</p>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            nfcTag: {
                name: "",
                uid: "",
                order: "",
            },
        }
    },
    created() {
        this.getNfcTag();
    },
    methods: {
        getNfcTag() {
            this.$store.getters.api.get(`/dashboard/${this.$route.params.slug}/nfc/${this.$route.params.id}`)
            .then(response => {
                this.nfcTag = response.data;
            })
            .catch(error => {
                console.error("Error loading nfc tag.", error);
            });
        },
        validateData() {
            const form = this.$refs.form;
            if (!form.checkValidity()) {
                form.reportValidity();
                return false;
            }
            return true;
        },
        submitForm() {
            const slug = this.$route.params.slug;
            const id = this.$route.params.id;
            const router = this.$router;
            const routeName = "NfcTagDetailView"

            if (!this.validateData()) return;

            this.$store.getters.api.patch(`/dashboard/${slug}/nfc/${id}/edit`, this.nfcTag)
            .then(() => {
                this.$router.replace({
                    name: "NfcTagDetailView",
                    params: {
                        slug: this.$route.params.slug,
                        id: this.$route.params.id
                    }
                })
            })
            .catch(error => {
                console.error("Error updating NFC tag.", error);
            });
        }
    }
}
</script>